// /src/context/NavbarContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const NavbarContext = createContext();

export const useNavbar = () => useContext(NavbarContext);

export const NavbarProvider = ({ children }) => {
  const [isNavbarOpen, setNavbarOpen] = useState(() => {
    try {
      const saved = localStorage.getItem('navbarOpen');
      return saved === null ? false : saved === 'true';
    } catch {
      return false;
    }
  });

  const toggleNavbar = () => {
    setNavbarOpen((prev) => {
      const next = !prev;
      try { localStorage.setItem('navbarOpen', String(next)); } catch {}
      return next;
    });
  };

  useEffect(() => {
    try { localStorage.setItem('navbarOpen', String(isNavbarOpen)); } catch {}
  }, [isNavbarOpen]);

  return (
    <NavbarContext.Provider value={{ isNavbarOpen, toggleNavbar }}>
      {children}
    </NavbarContext.Provider>
  );
};
